import { useQuery } from "@apollo/client";
import { SignedUrlToUploadFileDocument } from "../../__generated__/graphql";

export default function useSignedUrlToUploadFile(bucketKey: string) {
  const { data, loading, error } = useQuery(SignedUrlToUploadFileDocument, {
    variables: { bucketKey },
  });

  return { data, loading, error };
}
